import { createReducer, on } from '@ngrx/store';
import * as GlobalActions from './global.actions';

export interface GlobalState {
   countryCode: string;
   isCountryCodeResolved: boolean;
}

export const initialState: GlobalState = {
   countryCode: 'US',
   isCountryCodeResolved: false,
};

export const globalReducer = createReducer(
   initialState,

   on(GlobalActions.setCountryCode, (state, { countryCode }) => ({
      ...state,
      countryCode,
      isCountryCodeResolved: true,
   })),

   on(GlobalActions.setCountryCodeResolutionPending, (state) => ({
      ...state,
      isCountryCodeResolved: false,
   })),

   on(GlobalActions.setCountryCodeResolutionComplete, (state) => ({
      ...state,
      isCountryCodeResolved: true,
   }))
);
